import { render } from "./search-filter-additional-quota-requests.vue?vue&type=template&id=4a84d549&scoped=true"
import script from "./search-filter-additional-quota-requests.vue?vue&type=script&lang=js"
export * from "./search-filter-additional-quota-requests.vue?vue&type=script&lang=js"

import "./search-filter-additional-quota-requests.vue?vue&type=style&index=0&id=4a84d549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a84d549"]])

export default __exports__